import LoadingBox from 'components/Common/Loading/LoadingBox'
import React from 'react'

function BusinessTravellerSelectLoadingSkeleton() {
  return <LoadingBox />
}

export default BusinessTravellerSelectLoadingSkeleton
